var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C-6.65459e-08 16.9658 2.38249 21.0924 6.25 23.3253C10.1175 25.5582 14.8825 25.5582 18.75 23.3253C22.6175 21.0924 25 16.9658 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5Z",
    fill: "#00BCF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7377 12.3497L14.5616 17.7743C14.0371 18.2725 13.1832 17.8919 13.1832 17.1598V14.4262C12.9742 14.4109 12.7647 14.403 12.5551 14.4026C9.72658 14.4026 7.26136 15.718 5.96594 17.6686C5.69927 18.0668 5.09482 17.9144 5.04326 17.4346C5.01439 17.1738 4.99995 16.9116 5 16.6492C5 12.5577 8.55145 9.17179 13.1862 8.57438V5.84022C13.1862 5.10807 14.0401 4.72752 14.5646 5.22566L20.7406 11.123C20.907 11.2842 21.0006 11.5057 21 11.737C20.9994 11.9682 20.9048 12.1894 20.7377 12.3497Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.529e8063.svg";
export { ForwardRef as ReactComponent };